import React, {Component} from 'react';
import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import NumberFormat from 'react-number-format';
import {Pie} from 'react-chartjs-2';
import {isEmpty} from 'lodash';
import 'chart.piecelabel.js';

import {getPermission, getUser} from '../../utils/TokenManager';
import {AGENCY_PERFORMANCE_REPORT} from "../common/Constants";
import ErrorMsg from "../common/ErrorMsg";
import loadingGIF from "../../public/assets/images/loading.gif";


const options = {
    maintainAspectRatio: true,
    responsive: true,
	legend: {
		display: true,
		position: "right",
		labels: {
            fontSize: 10,
            boxWidth: 10
        }
    },
    pieceLabel: {
        render: 'value',
        fontSize: 12,
        fontStyle: 'bold',
        fontColor: '#000'
    },
    plugins: {
        datalabels: {
            display: false
        }
    }
}

const departmentPieChart = {
    labels: [],
    datasets: [{
        data: [],
        backgroundColor: []
    }]
};

const jobTitlePieChart = {
    labels: [],
    datasets: [{
        data: [],
        backgroundColor: []
    }]
};

const userPieChart = {
    labels: [],
    datasets: [{
        data: [],
        backgroundColor: []
    }]
};

const LOCATION_TAB = 'location_tab';
const AGENCY_TAB = 'agency_tab';
const INDIVIDUAL_TAB = 'individual_tab';
const STAFF_REVENUE = 'staff_revenue';

export default class AgencyPerformance extends Component {
    
    state = {
        performanceScore: {},
        combinedPerformanceData: {},
        isLoading: false,
        activeTab: LOCATION_TAB,
        userId: 0,
        individualPerformanceData: {}, 
        totalLocation: 1,
        userListData: []
    };

    auth = {
		user: getUser(),
		permission: getPermission()[AGENCY_PERFORMANCE_REPORT]
	}

    componentDidMount = () => {
        this.getLocationCount();
        if (this.props.agencyLocation) {
            this.getPerformanceScores();
        }
        this.getCombinedPerformanceScore();
    };

    getPerformanceScores = async () => {
        if (this.auth.permission.can_view) {
            this.setState({isLoading: true});
            try {
                let result = await this.props.getPerformanceScores(this.props.agencyLocation);
                if (result) {
                    let performanceScore = {...result};
                    this.setState({performanceScore});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
            this.setState({isLoading: false});
        }
    }

    getLocationCount = async () => {
            try {
            let result = await this.props.getLocationCount();
            if (result) {
                let totalLocation = result.count;
                this.setState({totalLocation});
            }
        } catch (error) {
            toast.error(<ErrorMsg errors={error}/>);
        }
    }

    toggleTab = async (activeTab) => {
        this.setState({activeTab});
        if (activeTab === INDIVIDUAL_TAB || activeTab === STAFF_REVENUE) {
            try {
                let result = await this.props.getDashboardUserList();
                if (result) {
                    this.setState({userListData: [...result]});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }    
        } else if (activeTab === AGENCY_TAB) {
            this.getCombinedPerformanceScore();
        } else if (activeTab === LOCATION_TAB) {
            this.getPerformanceScores();
        }
    }

    getCombinedPerformanceScore = async() => {
        if (this.auth.permission.can_view) {
            try {
                let result = await this.props.getCombinedPerformanceScores();
                if (result) {
                    let combinedPerformanceData = {...result};
                    this.setState({combinedPerformanceData});
                }
            } catch (error) {
                toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
            }
        }
    }

    userChangeHandler = (event) => {
        if (event.currentTarget.value > 0) {
            let userId = parseInt(event.currentTarget.value);
            this.setState({userId});
            this.getUserPerformanceData(userId);
        }
    };

    getUserPerformanceData = async(userId) => {
        if (this.auth.permission.can_view) {
            if (userId > 0) {
                this.setState({isLoading: true});
                try {
                    let data = await this.props.getIndividualPerformanceData(userId);

                    if (data) {
                        this.setState({individualPerformanceData: data});
                    }
                } catch (error) {
                    toast.error(<ErrorMsg errors={error}/>, {autoClose: 5000});
                }
                this.setState({isLoading: false});    
            }
        }
    }

    renderPerformanceData = (performanceScore) => {
        let departmentScores = [], departmentLabels = [], departmentColors = [];
        let jobTitleScores = [], jobTitleLabels = [], jobTitleColors = [];
        let userScores = [], userLabels = [], userColors = [];

        if (! isEmpty(performanceScore)) {
            // Departments jab title scores
            Object.keys(performanceScore.department_score).forEach(key => {
                departmentLabels.push(key);
                departmentScores.push(performanceScore.department_score[key]);
                departmentColors.push("#" + ("000000"+(Math.random()*(1<<24)|0).toString(16)).slice(-6))
            });
            departmentPieChart.datasets[0].data = departmentScores;
            departmentPieChart.labels = departmentLabels;
            departmentPieChart.datasets[0].backgroundColor = departmentColors;

            // Handle jab title scores
            Object.keys(performanceScore.job_title_score).forEach(key => {
                jobTitleLabels.push(key);
                jobTitleScores.push(performanceScore.job_title_score[key]);
                jobTitleColors.push("#" + ("000000"+(Math.random()*(1<<24)|0).toString(16)).slice(-6))
            });
            jobTitlePieChart.datasets[0].data = jobTitleScores;
            jobTitlePieChart.labels = jobTitleLabels;
            jobTitlePieChart.datasets[0].backgroundColor = jobTitleColors;

            // Handle User individual scores
            Object.keys(performanceScore.user_score).forEach(key => {
                userLabels.push(key);
                userScores.push(performanceScore.user_score[key]);
                userColors.push("#" + ("000000"+(Math.random()*(1<<24)|0).toString(16)).slice(-6))
            });
            userPieChart.datasets[0].data = userScores;
            userPieChart.labels = userLabels;
            userPieChart.datasets[0].backgroundColor = userColors;
        }
    }

    render() {
        const {
            performanceScore, activeTab, individualPerformanceData, 
            combinedPerformanceData, totalLocation, userListData
        } = this.state; 
        activeTab === LOCATION_TAB ? 
            this.renderPerformanceData(performanceScore) 
        : activeTab === AGENCY_TAB ? 
            this.renderPerformanceData(combinedPerformanceData)
        : null;

        let userListOption = [];
        if (userListData && userListData.length) {
            userListOption = userListData.map((list) =>
                <option key={list.id} value={list.id}>{list.full_name}</option>
            );
        }

        let individualDataRow = [];

        if (! isEmpty(individualPerformanceData)){
            individualPerformanceData.assigned_kpi_list.map((kpi, index) => {
                individualDataRow.push(
                    <tr key={index}>
                        <td style={{minWidth: "250px"}} className="align-middle">{kpi.kpi_name}</td>
                        {kpi.data_type === "Currency" ? 
                            <React.Fragment>
                                {individualPerformanceData.goal ? 
                                    <td className="text-center align-middle">
                                        <NumberFormat value={kpi.total_goal} displayType={'text'} 
                                            thousandSeparator={true} decimalScale={2} 
                                            prefix={'$ '} />
                                    </td>
                                    : null
                                }
                                <td className="text-center align-middle">
                                    <NumberFormat value={kpi.total_achieved_goal} 
                                        displayType={'text'} thousandSeparator={true} 
                                        decimalScale={2} prefix={'$ '} />
                                </td>
                                {individualPerformanceData.goal ? 
                                    <td className="text-center align-middle">
                                        <NumberFormat value={kpi.period_meet_goal} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} prefix={'$ '} />
                                    </td>
                                    : null
                                }
                                <td className="text-center align-middle">
                                    <NumberFormat value={kpi.actual_achieved} 
                                        displayType={'text'} thousandSeparator={true} 
                                        decimalScale={2} prefix={'$ '} />
                                </td>
                            </React.Fragment>
                        : kpi.data_type === "Percentage" ? 
                            <React.Fragment>
                                {individualPerformanceData.goal ? 
                                    <td className="text-center align-middle">
                                        <NumberFormat value={kpi.total_goal} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} suffix={' %'} />
                                    </td>
                                    : null
                                }
                                <td className="text-center align-middle">
                                    <NumberFormat value={kpi.total_achieved_goal} 
                                        displayType={'text'} thousandSeparator={true} 
                                        decimalScale={2} suffix={' %'} />
                                </td>
                                {individualPerformanceData.goal ? 
                                    <td className="text-center align-middle">
                                        <NumberFormat value={kpi.period_meet_goal} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} suffix={' %'} />
                                    </td>
                                    : null
                                }
                                <td className="text-center align-middle">
                                    <NumberFormat value={kpi.actual_achieved} 
                                        displayType={'text'} thousandSeparator={true} 
                                        decimalScale={2} suffix={' %'} />
                                </td>
                            </React.Fragment>
                        : 
                            <React.Fragment>
                                {individualPerformanceData.goal ? 
                                    <td className="text-center align-middle">
                                        <NumberFormat value={kpi.total_goal} 
                                        displayType={'text'} thousandSeparator={true} 
                                        decimalScale={2} />
                                    </td>
                                    : null
                                }
                                <td className="text-center align-middle">
                                    <NumberFormat value={kpi.total_achieved_goal} 
                                    displayType={'text'} thousandSeparator={true} 
                                    decimalScale={2} />
                                </td>
                                {individualPerformanceData.goal ? 
                                    <td className="text-center align-middle">
                                        <NumberFormat value={kpi.period_meet_goal} 
                                        displayType={'text'} thousandSeparator={true} 
                                        decimalScale={2} />
                                    </td>
                                    : null
                                }
                                <td className="text-center align-middle">
                                    <NumberFormat value={kpi.actual_achieved} 
                                    displayType={'text'} thousandSeparator={true} 
                                    decimalScale={2} />
                                </td>
                            </React.Fragment>
                        }
                        {individualPerformanceData.score ? 
                            <React.Fragment>
                                <td className="text-center align-middle">{kpi.max_score}</td> 
                                <td className="text-center align-middle">
                                    <NumberFormat value={kpi.evaluation_score} 
                                    displayType={'text'} thousandSeparator={true} 
                                    decimalScale={2} />
                                </td>
                            </React.Fragment>
                            : null
                        }
                        {individualPerformanceData.goal ? 
                            <td className="text-center align-middle">
                                <NumberFormat value={kpi.goal_per} displayType={'text'} 
                                thousandSeparator={true} decimalScale={2} 
                                fixedDecimalScale={true} suffix={' %'} />
                            </td>
                            : null
                        }
                    </tr>
                );
            });
        }

        return (
            this.auth.permission.can_view ?
                <div className="tab-pane" role="tabpanel">
                    <div className="row">
                        <div className="col-sm-6">
                            <label className="bg-score text-white py-1 px-2 font-16 width-300">
                                <span className="float-left">
                                    {totalLocation > 1 ? "Current Location" : "Agency"} Evaluation Score: 
                                </span>
                                <span className="font-18 box-text-shadow float-right font-weight-bold">
                                    {performanceScore ? 
                                        <NumberFormat value={performanceScore.agency_avg_score} 
                                            displayType={'text'} thousandSeparator={true} 
                                            decimalScale={2} fixedDecimalScale={true} /> 
                                        : 0.00
                                    }
                                </span>
                            </label>
                        </div>
                        {totalLocation > 1 &&
                            <div className="col-sm-6 text-sm-right">
                                <label className="bg-score text-white py-1 px-2 font-16 width-300">
                                    <span className="float-left">All Locations Evaluation Score: </span>
                                    <span className="font-18 box-text-shadow float-right font-weight-bold">
                                        {combinedPerformanceData ? 
                                            <NumberFormat value={combinedPerformanceData.agency_avg_score} 
                                                displayType={'text'} thousandSeparator={true} 
                                                decimalScale={2} fixedDecimalScale={true} /> 
                                            : 0.00
                                        }
                                    </span>
                                </label>
                            </div>
                        }
                    </div>
                    <div className="w-block">
                        <ul className="nav nav-tabs" role="tablist">
                            <li className="nav-item" onClick={() => this.toggleTab(LOCATION_TAB)}>
                                <a className={`nav-link ${activeTab === LOCATION_TAB && "active"}`} 
                                        data-toggle="tab" role="tab">
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">
                                        {totalLocation > 1 ? "Current Location" : "Agency"}
                                    </span>
                                </a>
                            </li>
                            {totalLocation > 1 &&
                                <li className="nav-item" onClick={() => this.toggleTab(AGENCY_TAB)}>
                                    <a className={`nav-link ${activeTab === AGENCY_TAB && "active"}`} 
                                            data-toggle="tab" role="tab">
                                        <span className="hidden-sm-up"></span>
                                        <span className="hidden-xs-down">All Locations</span>
                                    </a>
                                </li>
                            }
                            <li className="nav-item" onClick={() => this.toggleTab(INDIVIDUAL_TAB)}>
                                <a className={`nav-link ${activeTab === INDIVIDUAL_TAB && "active"}`} 
                                        data-toggle="tab" role="tab">
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">Individual</span>
                                </a>
                            </li>
                        </ul>

                        <div className="tab-content bg-white border border-top-0 p-3">
                        {activeTab === LOCATION_TAB ? 
                            <div className="row">
                                <div className="col-sm-4 text-center">
                                    <div className="w-block border rounded h-100">
                                        <label>Department Evaluation Scores</label>
                                        <Pie data={departmentPieChart} 
                                            width={150} height={150} 
                                            options={options} />
                                    </div>
                                </div>
                                <div className="col-sm-4 text-center">
                                    <div className="w-block border rounded h-100">
                                        <label>Individual Evaluation Scores</label>
                                        <Pie data={userPieChart} 
                                            width={150} height={150} 
                                            options={options} />
                                    </div>
                                </div>
                                <div className="col-sm-4 text-center">
                                    <div className="w-block border rounded h-100">
                                        <label>Job Title Evaluation Scores</label>
                                        <Pie data={jobTitlePieChart} 
                                            width={150} height={150} 
                                            options={options} />
                                    </div>
                                </div>
                            </div>
                        : activeTab === AGENCY_TAB ? 
                            <div className="row">
                                <div className="col-sm-4 text-center">
                                    <div className="w-block border rounded h-100">
                                        <label>Department Evaluation Scores</label>
                                        <Pie data={departmentPieChart} 
                                            width={150} height={150} 
                                            options={options} />
                                    </div>
                                </div>
                                <div className="col-sm-4 text-center">
                                    <div className="w-block border rounded h-100">
                                        <label>Individual Evaluation Scores</label>
                                        <Pie data={userPieChart} 
                                            width={150} height={150} 
                                            options={options} />
                                    </div>
                                </div>
                                <div className="col-sm-4 text-center">
                                    <div className="w-block border rounded h-100">
                                        <label>Job Title Evaluation Scores</label>
                                        <Pie data={jobTitlePieChart} 
                                            width={150} height={150} 
                                            options={options} />
                                    </div>
                                </div>
                            </div>
                        : activeTab === INDIVIDUAL_TAB ? 
                            <React.Fragment>
                                <div className="w-block border rounded">
                                    <div className="row">
                                        <div className="col-sm-3">
                                            <label className="mb-1">Select User</label>
                                            <select name="user_name" className="form-control"
                                                    onChange={this.userChangeHandler}
                                                    value={this.state.userId}>
                                                <option key="0" value="0">Select a staff</option>
                                                {userListOption}
                                            </select>
                                        </div>
                                        <div className="col-sm-4 text-center">
                                            <label className="mb-1">Compensation Period</label>
                                            <input className="text-center font-weight-bold 
                                                                font-16 form-control" 
                                                disabled={true} 
                                                value={individualPerformanceData.period_dates ? 
                                                    individualPerformanceData.period_dates 
                                                    : (!isEmpty(individualPerformanceData)) ? 
                                                    "No compensation profile enabled currently" : ""} 
                                            />
                                        </div>
                                        {individualPerformanceData.score && 
                                            <div className="col-sm-2 text-center">
                                                <label className="mb-1">Current Score</label>
                                                <input className={
                                                    `text-center font-weight-bold font-16 form-control 
                                                    ${individualPerformanceData.personal_evaluation_score >= 
                                                        individualPerformanceData.should_have_evaluation_score ? 
                                                        "text-success" : "text-danger"}`} 
                                                    disabled={true} 
                                                    value={individualPerformanceData.personal_evaluation_score} 
                                                />
                                            </div>
                                        }
                                        {individualPerformanceData.score &&
                                            <div className="col-sm-3 text-center">
                                                <label className="mb-1">Should Have Score</label>
                                                <input className="text-center font-weight-bold 
                                                            font-16 form-control" 
                                                    disabled={true} 
                                                    value={individualPerformanceData.should_have_evaluation_score} 
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12 mt-3">
                                        <Table responsive striped bordered size={"sm"} 
                                            className="mb-0"
                                        >
                                            <thead className="bg-f5">
                                                <tr>
                                                    <th className="font-weight-bold">KPI Name</th>
                                                    {individualPerformanceData.goal ? 
                                                        <th className="font-weight-bold text-center">
                                                            Total Compensation <br/> Plan Goal
                                                        </th>
                                                        : null
                                                    }
                                                    <th className="font-weight-bold text-center">
                                                        YTD Actual
                                                    </th>
                                                    {individualPerformanceData.goal ? 
                                                        <th className="font-weight-bold text-center">
                                                            Current Period <br/> Meet Goal
                                                        </th>
                                                        : null
                                                    }
                                                    <th className="font-weight-bold text-center">
                                                    Current Period <br/> Actual</th>
                                                    {individualPerformanceData.score ? 
                                                        <React.Fragment>
                                                            <th className="font-weight-bold text-center">
                                                                Maximum Score
                                                            </th>
                                                            <th className="font-weight-bold text-center">
                                                                Actual Score
                                                            </th>
                                                        </React.Fragment>
                                                        : null
                                                    }
                                                    {individualPerformanceData.goal ? 
                                                        <th className="font-weight-bold text-center">
                                                            % Achieved
                                                        </th>
                                                        : null
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr></tr>
                                                {
                                                    individualDataRow.length ? 
                                                        individualDataRow
                                                    :
                                                    <tr><td colSpan="8" className="text-center">
                                                        No Data available
                                                        </td></tr>
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </React.Fragment>
                        : 
                            null
                        }
                        {this.state.isLoading && 
                            <p className="loading-gif">
                                <img src={loadingGIF} alt="Loading..." width="32" height="32"/>
                            </p>
                        }
                        </div>
                    </div>
                </div>
            : <div className="tab-pane text-center" role="tabpanel">
                Access Denied
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/agencyPerformance/AgencyPerformance.js